"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("element-closest");
var SubSubMenuToggle = (function () {
    function SubSubMenuToggle() {
        this.subSubNavToggles = document.querySelectorAll('.toggle-sub-nav');
        this.subSubNavTogglesCount = this.subSubNavToggles.length;
        for (var i = 0; i < this.subSubNavTogglesCount; ++i) {
            this.subSubNavToggles.item(i).addEventListener('click', function (e) {
                e.preventDefault();
                e.target.closest('.menu-item').classList.toggle('show-sub-nav');
            });
        }
    }
    SubSubMenuToggle.getInstance = function () {
        if (!this.instance) {
            this.instance = new SubSubMenuToggle();
        }
        return this.instance;
    };
    return SubSubMenuToggle;
}());
exports.default = SubSubMenuToggle;
